import { cn } from "@theprelude/core";

export const OidcIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.08435 15.9998L9.58175 14.2092L9.4656 0L7.08435 1.84836V15.9998Z" />
    <path d="M6.66655 4.75494C-2.48487 6.65639 -2.09907 14.5434 7.1136 16L7.08456 14.4116C1.29354 13.5394 0.349106 7.72947 6.66655 6.43134V4.75494Z" />
    <path d="M9.99983 6.32472C10.972 6.44186 11.8462 6.8999 12.7185 7.36471L11.2375 8.46217H15.971L16 5.25643L14.519 6.35389C14.3009 6.24436 14.0855 6.13165 13.87 6.01894C12.7125 5.41343 11.5549 4.80793 9.99983 4.69666V6.32472Z" />
  </svg>
);
